import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "components/Header";
import Footer from "components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const f = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", f, { passive: true });
    return () => window.removeEventListener("scroll", f);
  }, []);
  return (
    <button
      aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-[900] w-12 h-12 rounded-full bg-green text-white shadow-[0_6px_24px_rgba(0,60,43,0.4)] flex items-center justify-center text-2xl transition-all duration-300 hover:bg-green-dark hover:-translate-y-0.5 active:scale-95"
      style={{
        opacity: show ? 1 : 0,
        transform: show ? "translateY(0)" : "translateY(16px)",
        pointerEvents: show ? "auto" : "none",
      }}
    >
      ↑
    </button>
  );
}

export default function Layout() {
  const location = useLocation();

  // Scroll to top on route change (instant — the click handler already does a
  // smooth scroll; this covers browser back/forward and deep links).
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [location.pathname]);

  return (
    <div>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}
